(function () {
  const STORAGE_KEY = 'kmi_min_yardage';

  function getStoredMins() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}'); }
    catch (e) { return {}; }
  }

  function storeMins(data) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data)); }
    catch (e) {}
  }

  function applyToQtyEl(qtyEl, itemMin) {
    if (!itemMin || itemMin < 1) return;
    const input = qtyEl.querySelector('input');
    const minusBtn = qtyEl.querySelector('[name="minus"]');
    if (!input) return;
    input.setAttribute('min', itemMin);
    if (parseInt(input.value) < itemMin) input.value = itemMin;
    const newInput = input.cloneNode(true);
    input.parentNode.replaceChild(newInput, input);
    function check() {
      if (parseInt(newInput.value) < itemMin) newInput.value = itemMin;
      if (minusBtn) minusBtn.disabled = parseInt(newInput.value) <= itemMin;
    }
    newInput.addEventListener('change', check);
    newInput.addEventListener('input', check);
    check();
  }

  // ── PRODUCT PAGE ─────────────────────────────────────────────────────────
  function initProductPage() {
    const min = window.KMI && window.KMI.minYardage;
    if (!min) return;

    const storedMins = getStoredMins();
    document.querySelectorAll('script[type="application/json"]').forEach(function(s) {
      if (!s.textContent.includes('Yardage') && !s.textContent.includes('Sample')) return;
      try {
        const data = JSON.parse(s.textContent);
        const variants = Array.isArray(data) ? data : (data.variants || [data]);
        variants.forEach(function(v) {
          const isSample = ['option1','option2','option3','title'].some(function(k) {
            return v[k] && v[k].toLowerCase().includes('sample');
          });
          if (!isSample && v.id) storedMins[v.id] = min;
        });
      } catch(e) {}
    });
    storeMins(storedMins);

    function getSelectedVariantId() {
      const input = document.querySelector('product-info input[name="id"]');
      if (input) return input.value;
      return new URLSearchParams(window.location.search).get('variant');
    }

    function initMain() {
      console.log('[KMI] initMain called');
      const productInfo = document.querySelector('product-info');
      if (!productInfo) { console.log('[KMI] no product-info'); return; }

      const qtyInput = productInfo.querySelector('input[name="quantity"]');
      const addToCartBtn = productInfo.querySelector('[name="add"]');
      if (!qtyInput || !addToCartBtn) { console.log('[KMI] no qtyInput or addToCartBtn'); return; }

      const selectedId = getSelectedVariantId();
      const activeMin = selectedId ? getStoredMins()[selectedId] : null;
      console.log('[KMI] selectedId:', selectedId, 'activeMin:', activeMin);

      const existingMsg = productInfo.querySelector('.kmi-qty-error');
      if (existingMsg) existingMsg.remove();

      if (!activeMin || activeMin < 1) {
        console.log('[KMI] no activeMin — resetting');
        qtyInput.removeAttribute('min');
        if (parseInt(qtyInput.value) < 1) qtyInput.value = 1;
        addToCartBtn.disabled = false;
        return;
      }

      console.log('[KMI] setting min to', activeMin);
      qtyInput.setAttribute('min', activeMin);
      if (parseInt(qtyInput.value) < activeMin) qtyInput.value = activeMin;

      const msg = document.createElement('p');
      msg.className = 'kmi-qty-error';
      msg.style.cssText = 'color:red; font-size:0.8rem; margin-top:0.25rem; display:none;';
      msg.textContent = 'Minimum order is ' + activeMin + ' yards.';
      const qtyWrapper = qtyInput.closest('.quantity') || qtyInput;
      qtyWrapper.insertAdjacentElement('afterend', msg);

      function validate() {
        const val = parseInt(qtyInput.value) || 0;
        msg.style.display = val < activeMin ? 'block' : 'none';
        addToCartBtn.disabled = val < activeMin;
      }
      qtyInput.addEventListener('change', validate);
      qtyInput.addEventListener('input', validate);
      validate();
    }

    function initSticky() {
    const stickyBar = document.querySelector('sticky-atc-bar');
    if (!stickyBar) return;
    const selectedId = getSelectedVariantId();
    const activeMin = selectedId ? getStoredMins()[selectedId] : null;
    if (!activeMin) return;
    const qtyEl = stickyBar.querySelector('quantity-input, quantity-selector');
    if (!qtyEl) return;
    const input = qtyEl.querySelector('input');
    const minusBtn = qtyEl.querySelector('[name="minus"]');
    if (!input) return;
    input.setAttribute('min', activeMin);
    if (parseInt(input.value) < activeMin) input.value = activeMin;
    if (minusBtn) minusBtn.disabled = parseInt(input.value) <= activeMin;
    input.addEventListener('change', function() {
        if (parseInt(input.value) < activeMin) input.value = activeMin;
        if (minusBtn) minusBtn.disabled = parseInt(input.value) <= activeMin;
    });
    input.addEventListener('input', function() {
        if (parseInt(input.value) < activeMin) input.value = activeMin;
        if (minusBtn) minusBtn.disabled = parseInt(input.value) <= activeMin;
    });
    }


    initMain();
    setTimeout(initSticky, 500);

    document.addEventListener('cart:close', initMain);
    document.addEventListener('drawer:close', initMain);
    document.addEventListener('cart:add', function() { setTimeout(initMain, 300); });
    document.addEventListener('variant:change', function() { setTimeout(initSticky, 300); });
    document.addEventListener('change', function(e) {
  if (e.target.matches('sticky-atc-bar select, sticky-atc-bar input[name="id"]')) {
    setTimeout(initSticky, 600);
  }
  if (e.target.matches('select[name="id"], input[name="id"]')) {
    setTimeout(initSticky, 600);
  }
    });

    function subscribeVariantChange() {
      if (window.FoxTheme && window.FoxTheme.pubsub && window.FoxTheme.pubsub.PUB_SUB_EVENTS && window.FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange) {
        window.FoxTheme.pubsub.subscribe(window.FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function() {
          setTimeout(initMain, 150);
          setTimeout(initSticky, 300);
        });
      } else {
        setTimeout(subscribeVariantChange, 500);
      }
    }
    subscribeVariantChange();

    const productInfo = document.querySelector('product-info');
    if (productInfo) {
      productInfo.addEventListener('change', function(e) {
        if (e.target.matches('input[name="id"], select[name="id"]')) {
          setTimeout(initMain, 100);
        }
      });

      new MutationObserver(function() {
        const qi = productInfo.querySelector('input[name="quantity"]');
        const currentMin = parseInt(qi && qi.getAttribute('min') || '0');
        const selectedId = getSelectedVariantId();
        const expectedMin = selectedId ? getStoredMins()[selectedId] : null;
        if (expectedMin && currentMin !== expectedMin) {
          setTimeout(initMain, 50);
        }
      }).observe(productInfo, { subtree: true, attributes: true, childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductPage);
  } else {
    initProductPage();
  }

  // ── CART DRAWER & CART PAGE ──────────────────────────────────────────────
  function enforceCartQtyInputs() {
    const storedMins = getStoredMins();
    if (!Object.keys(storedMins).length) return;
    document.querySelectorAll('quantity-input').forEach(function(qtyEl) {
      const input = qtyEl.querySelector('input[name="updates[]"]');
      if (!input) return;
      const variantId = input.getAttribute('data-quantity-variant-id');
      const itemMin = variantId ? storedMins[variantId] : null;
      if (!itemMin || itemMin < 1) return;
      const minusBtn = qtyEl.querySelector('[name="minus"]');
      input.setAttribute('min', itemMin);
      if (parseInt(input.value) < itemMin) input.value = itemMin;
      if (minusBtn) minusBtn.disabled = parseInt(input.value) <= itemMin;
      input.addEventListener('change', function() {
        if (parseInt(input.value) < itemMin) input.value = itemMin;
        if (minusBtn) minusBtn.disabled = parseInt(input.value) <= itemMin;
      });
      input.addEventListener('input', function() {
        if (parseInt(input.value) < itemMin) input.value = itemMin;
        if (minusBtn) minusBtn.disabled = parseInt(input.value) <= itemMin;
      });
    });
  }

  function subscribeToFoxPubSub() {
    if (window.FoxTheme && window.FoxTheme.pubsub && window.FoxTheme.pubsub.PUB_SUB_EVENTS) {
      window.FoxTheme.pubsub.subscribe(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function() {
        setTimeout(enforceCartQtyInputs, 400);
      });
    } else {
      setTimeout(subscribeToFoxPubSub, 500);
    }
  }

  document.addEventListener('cart:updated', function() { setTimeout(enforceCartQtyInputs, 400); });

  document.addEventListener('DOMContentLoaded', function() {
    subscribeToFoxPubSub();

    const cartDrawer = document.querySelector('cart-drawer, #CartDrawer, [id*="cart-drawer"]');
    if (cartDrawer) {
      new MutationObserver(function() { setTimeout(enforceCartQtyInputs, 150); })
        .observe(cartDrawer, { childList: true, subtree: true });
    }

    if (window.location.pathname.includes('/cart')) {
      console.log('[KMI] cart page detected — starting interval');
      let attempts = 0;
      const cartInterval = setInterval(function() {
        console.log('[KMI] cart interval attempt', attempts + 1);
        enforceCartQtyInputs();
        attempts++;
        if (attempts >= 20) clearInterval(cartInterval);
      }, 500);

      const cartSection = document.getElementById('shopify-section-template--17726898864225__main-cart');
      if (cartSection) {
        new MutationObserver(function() { setTimeout(enforceCartQtyInputs, 150); })
          .observe(cartSection, { childList: true, subtree: true });
      }
    }

  });

})();
